/**
 * Classifies a GraphQL error as "validation-class" — the observed-breakage
 * signal for an old tab replaying a stale full-text (APQ-fallback) query
 * against a schema that no longer supports it (MEIS-13220, design.md D6).
 *
 * PRIMARY match is by message pattern. `apps/backend/src/app/__test__/
 * graphqlValidationErrorShape.test.ts` pins that graphql-yoga@4 / graphql@15
 * emits a document-validation error for a full-text operation as HTTP 200
 * with `errors[].message` and NO `extensions` key at all — so
 * `extensions.code === "GRAPHQL_VALIDATION_FAILED"` can never fire against
 * this deployment; it is kept only as a defensive secondary for a future
 * Yoga version that might start populating it.
 */
const VALIDATION_ERROR_MESSAGE_PATTERN =
  /Cannot query field|Unknown argument|Unknown type/;

export interface ClassifiableGraphQLError {
  message?: string;
  extensions?: { code?: unknown } | null;
}

export function isValidationClassGraphQLError(
  error: ClassifiableGraphQLError | null | undefined
): boolean {
  if (!error) return false;

  if (error.extensions?.code === "GRAPHQL_VALIDATION_FAILED") return true;

  return (
    typeof error.message === "string" &&
    VALIDATION_ERROR_MESSAGE_PATTERN.test(error.message)
  );
}
